import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, STUB, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'brasileirao-serie-c';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('amazonas', 'Amazonas', uniform('amazonas', '#FFC300', '#000000')),
  team('abc', 'ABC FC', uniform('abc', STUB, STUB)),
  team('brasil-de-pelotas', 'Brasil de Pelotas', uniform('brasil-de-pelotas', STUB, STUB)),
  team('brusque', 'Brusque', uniform('brusque', STUB, STUB)),
  team('confianca', 'Confiança', uniform('confianca', STUB, STUB)),
  team('csa', 'CS Alagoano', uniform('csa', STUB, STUB)),
  team('ferroviaria', 'Ferroviária SAF', uniform('ferroviaria', LIGHT, '#000000')),
  team('guarani', 'Guaraní', uniform('guarani', STUB, STUB)),
  team('ituano', 'Ituano', uniform('ituano', STUB, STUB)),
  team('paysandu', 'Paysandu', uniform('paysandu', '#005684', LIGHT)),
  team('sampaio-correa', 'Sampaio Corrêa', uniform('sampaio-correa', STUB, STUB)),
  team('tombense', 'Tombense', uniform('tombense', STUB, STUB)),
  team('volta-redonda', 'Volta Redonda', uniform('volta-redonda', '#ECBB00', LIGHT))
];

export const brasileiraoSerieC: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(35, 44, 294, 338) },
  teams
};
